import { sha256 } from 'js-sha256';

import { getEncryptValue } from '@/utils';
import { API2_HOST } from '@/utils/constants';

import fetchData from '../http';
import request from '../request';
import { IBaseResponse, IResponseResult, IResult } from '../types/common';
import {
  IApplyCountResult,
  IBindParams,
  IChangeSubAccountPassword,
  IContractAsset,
  ICreateSubAccount,
  IListParams,
  IOperationChildAccount,
  ISubAccountRecord,
  ITotalBalance,
  IUpdateRemark,
} from '../types/subAccount';
import { getParams } from '../verify/index';

// 子账号创建
export function createSubmember({
  loginName,
  password,
  member_type,
  remark,
  authContext,
  allow_switch,
}: ICreateSubAccount) {
  const params = {
    loginName,
    remark,
    member_type: Number(member_type),
    password: password ? sha256(password) : password,
    auth_context: authContext,
    switch: allow_switch,
  };
  const url = `${API2_HOST}/v3/private/user/member/submember-create`;
  return new Promise((resolve, reject) => {
    getEncryptValue(params)
      .then((res: any) => {
        fetchData
          .post<IBaseResponse<IResult>>(url, {
            body: JSON.stringify(res),
          })
          .then((response) => {
            resolve(response.result);
          })
          .catch((error) => {
            reject(error.response ? error.response.data : error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// 校验子账号是否可用
export function verifySubmember(params: {
  params: {
    loginName: string;
  };
}) {
  const url = `${API2_HOST}/v3/private/user/member/submember-create-verify`;
  return fetchData.get(url, getParams(params));
}
// 子账号列表
export function getSubmemberList(params?: IListParams) {
  const url = `${API2_HOST}/user/private/list/sub-members`;
  return request.get<IBaseResponse<ISubAccountRecord>>(url, {
    ...getParams(params),
    useCache: true,
  });
}
// 母账号一键切换登录子账号
export function switchToSubAccount(params: IOperationChildAccount) {
  const url = `${API2_HOST}/v3/private/user/member/switch-login`;
  return fetchData.post(url, getParams(params));
}
// 母账号强踢子账号下线
export function kickSubAccount(params: IOperationChildAccount) {
  const url = `${API2_HOST}/v3/private/user/member/kick-submember`;
  return fetchData.post(url, getParams(params));
}

// 修改子账号备注
export function submemberRemarkEdit(params: IUpdateRemark) {
  const url = `${API2_HOST}/v3/private/user/member/submember-modify-remark`;
  return fetchData.post(url, getParams(params));
}
// 母账号给子账号重置密码
export function changeChildPassword(params: IChangeSubAccountPassword) {
  const url = `${API2_HOST}/v3/private/user/member/find-submember-password`;
  return fetchData.post(url, getParams(params));
}

// 修改子账户状态
export function changeStatus(member_id: string | number, status: number) {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/user/private/frozen/submember`;
    fetchData
      .post<IBaseResponse<IResponseResult>>(url, {
        body: JSON.stringify({ member_id, status }),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 删除子账号
export function deleteSubAccount(
  sub_member_id: string | number,
  verification_code: string,
) {
  const url = `${API2_HOST}/user/private/delete/submember`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResponseResult>>(url, {
        body: JSON.stringify({
          sub_member_id,
          verification_code,
        }),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 重置密码
export function resetSubAccountPassword(
  sub_member_id: string | number,
  new_password: string,
  verification_code: string,
) {
  const url = `${API2_HOST}/user/private/reset/password`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResponseResult>>(url, {
        body: JSON.stringify({
          sub_member_id: Number(sub_member_id),
          new_password: sha256(new_password),
          verification_code,
        }),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 获取子账号绑定谷歌2fa所需信息  secret / imgsrc
export function googlefa2(sub_member_id: string | number) {
  const url =
    `${API2_HOST}/v3/private/user/member/google2fa-info?sub_member_id=` +
    sub_member_id;
  return new Promise((resolve, reject) => {
    fetchData
      .get<IBaseResponse<IResponseResult>>(url, {})
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 重置谷歌校验
export function resetGoogle2fa(
  sub_member_id: string | number,
  google2fa_secret: string,
  google2fa_code: string,
) {
  const url = `${API2_HOST}/user/private/reset/google2fa`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResponseResult>>(url, {
        body: JSON.stringify({
          sub_member_id,
          google2fa_secret,
          google2fa_code,
        }),
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 获取绑定申请数量
export function getApplyCount() {
  const url = `${API2_HOST}/user/private/apply/count`;
  return new Promise((resolve, reject) => {
    request
      .get<IBaseResponse<IApplyCountResult>>(url, {
        useCache: true,
      })
      .then((response) => {
        resolve(response.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 获取绑定申请列表
export function getApplyList() {
  const url = `${API2_HOST}/user/private/apply/list`;
  return fetchData.get(url);
}

// 绑定申请同意或者拒绝
export function operatorBind(params: IBindParams) {
  const url = `${API2_HOST}/user/private/operator/submember/bind`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResponseResult>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 查询交易团队
export function searchExchangeTeam(exchangeID: string) {
  const url = `${API2_HOST}/user/private/query/exchange?exchangeID=${exchangeID}`;
  return fetchData.get(url);
}

// 行情列表
export const getAllInstrument = () => {
  const url = `${API2_HOST}/instrument/list`;
  return fetchData
    .get(url)
    .then((res: any) => {
      return res?.result;
    })
    .catch((error) => {
      return error?.response ? error?.response?.data : error;
    });
};

// 绑定交易团队
export function bindSubAccountToTeam(params: {
  sub_member_id: string;
  exchange_member_id: string;
  contract_path: string;
}) {
  const url = `${API2_HOST}/user/private/bind/submember/exchange`;
  return fetchData.post(url, getParams(params));
}

// 解绑交易团队
export function unBindAccountFromTeam(params: {
  sub_member_id: string;
  exchange_member_id: string;
}) {
  const url = `${API2_HOST}/user/private/unbind/submember/exchange`;
  return fetchData.post(url, getParams(params));
}

// 批量获取子账户资产（现货、合约、USDC、统一保证金）, 获取当前页所有子账户的资产
export function getSubMembersBalance(sub_member_ids?: string) {
  const url = `${API2_HOST}/user/private/get/sub-balance?sub_member_ids=${sub_member_ids}`;
  return fetchData.get<IBaseResponse<IContractAsset>>(url);
}

// 子账户快速切换接口
export function quickSwitch(member_id: string | number, status: number) {
  // status 1打开 0关闭
  const url = `${API2_HOST}/user/private/switch/open`;
  return fetchData.post<IBaseResponse<IResponseResult>>(url, {
    body: JSON.stringify({ sub_member_id: member_id, switch: status }),
  });
}

// 获取子账户总资产
export function getTotalBalance() {
  const url = `${API2_HOST}/user/private/total/sub-balance`;
  return request.get<IBaseResponse<ITotalBalance>>(url, { useCache: true });
}

// 子账号绑定google发送验证码
export function switchLogin({
  target_member_id,
}: {
  target_member_id: string;
}) {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/user/private/switch/login`;
    fetchData
      .post<IBaseResponse<IResponseResult>>(url, {
        body: JSON.stringify({ target_member_id }),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error: any) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 子账号解绑 2fa
export function unbindSubAccount2fa(params: {
  code: string; // 母账号绑定的2fa验证码
  sub_member_id: number | string; // 子账号UID
}) {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/user/private/unbind/sub-member/2fa`;
    fetchData
      .post<IBaseResponse<any>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error: any) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 获取子账号是否有未使用的卡券
export function getAvailableRewards({ userID }: { userID: string }) {
  const params = {
    pagination: {
      token: null,
      pageNum: 1,
      pageSize: 10,
      totalCount: null,
      pageCount: null,
    },
    filter: {
      lang: null,
      canUse: null,
      awardType: 'AWARD_TYPE_UNKNOWN',
      userID,
      award_id: [],
      returnAwardRecord: null,
      newOrderWay: true,
      rewardBusinessLine: 'REWARD_BUSINESS_LINE_DEFAULT',
      rewardStatus: 'REWARD_STATUS_AVAILABLE',
      getFirstAwardings: true,
      simpleField: true,
      specCode: null,
      specCodeValid: null,
      allow_amount_multiple: true,
      return_reward_packet: true,
    },
  };

  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/segw/awar/v1/awarding/search-together`;
    fetchData
      .post<IBaseResponse<any>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error: any) => {
        reject(error?.response ? error?.response?.data : error);
      });
  });
}
